import { render, staticRenderFns } from "./medicalcare.vue?vue&type=template&id=0bf915fc&scoped=true&"
import script from "./medicalcare.vue?vue&type=script&lang=js&"
export * from "./medicalcare.vue?vue&type=script&lang=js&"
import style0 from "./medicalcare.vue?vue&type=style&index=0&id=0bf915fc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf915fc",
  null
  
)

export default component.exports